export default __webpack_public_path__ + "static/media/MoeSzyslak.61c10c4f.png";